module.exports = __webpack_public_path__ + "img/dasd.ff437a09.png";